<div id="container-success-register-completed" class="register-completed container-fluid">
  <!-- <div class=""> -->
  <div class="d-flex align-items-center flex-column">
<!--    <lottie-animation-view [options]="lottieConfig" [width]="200" [height]="200">-->
<!--    </lottie-animation-view>-->
    <ng-lottie width="200px" [options]="optionsLottie"></ng-lottie>
  </div>
  <div id="div-success-acount-created" class="row title-row d-flex align-items-center justify-content-center">
    <div class="col-sm-8 col-md-6 col-lg-8 col-xl-6">
      <div class="title" [innerHTML]="message"></div>
    </div>
  </div>
  <div class="row mt-2 d-flex justify-content-center" *ngIf="!registerGoToIdentity">
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex align-items-center flex-column separator">
      <span class="card-title">Baixe nosso aplicativo</span>
      <span class="sub-title">Disponível no iOS e Android.</span>
      <div class="card-btns mt-2">
        <div class="row d-flex justify-content-center">
          <div class="col-4 p-0">
            <mat-icon id="btn-open-app-store" (click)="openAppStore()" svgIcon="apple-store"></mat-icon>
          </div>
          <div class="col-4 p-0">
            <mat-icon id="btn-open-google-play" (click)="openGooglePlay()" svgIcon="google-play"></mat-icon>
          </div>
        </div>
      </div>
      <span class="bordered-text">MOBILE</span>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex align-items-center flex-column separator">
      <span class="card-title">Acesse em qualquer navegador</span>
      <span class="sub-title">Em uma versão intuitiva, amigável</span>
      <div class="card-btns mt-2">
        <!-- <a [routerLink]="[ '/path', routeParam ]" mat-stroked-button id="btn-access-now" (click)="router.navigate(['/login'])">Acessar agora</a> -->
        <a [routerLink]="[ '/login' ]" mat-stroked-button id="btn-access-now" >Acessar agora</a>
      </div>
      <span class="bordered-text">WEB</span>
    </div>
    <div class="col-sm-12 col-md-6 col-lg-4 d-flex align-items-center flex-column">
      <span class="card-title">Para Traders Profissionais</span>
      <span class="sub-title">Uma plataforma robusta, completa</span>
      <div class="card-btns mt-2">
        <button id="btn-download-desktop" mat-stroked-button (click)="downloadDesktop()">Baixe agora</button>
        <img class="ml-1 pointer" src="/assets/images/png/windows-platform.png" alt="">
      </div>
      <span class="bordered-text">DESKTOP</span>
    </div>
  </div>
</div>
